<template>
	<div class="event-pass-offer-detail template-layout">
		<OfferHeaderBlock
			:contentData="contentData"
			@closePopup="$emit('closePopup', $event)"
		/>
		<OfferRibbonBlock :contentData="contentData" />
		<OfferContentBlock :skin="contentData.attributes?.skin">
			<template #content>
				<div class="event-pass-offer-detail__content">
					<div class="event-pass-offer-detail__content-ribbon">
						<span>{{ translate("ui.extra_rewards") }}</span>
					</div>
					<span class="event-pass-offer-detail__content-cta">
						{{
							translate(`offer.lok_${eventAttributes.type}_pass`)
						}}
					</span>
					<div
						class="event-pass-offer-detail__content-rewards"
						:style="{
							backgroundImage: `url('${IMAGES_CDN_URL}/shop/backgrounds/templates/event-pass/${eventAttributes.type}/event-pass-reward-img.avif')`,
						}"
					/>

					<div class="event-pass-offer-detail__content-info">
						<span>{{ translate("event.event_pass_info") }}</span>
					</div>
				</div>
			</template>
		</OfferContentBlock>
	</div>
</template>

<script lang="ts" setup>
import OfferContentBlock from "@/components/shop/blocks/OfferContentBlock.vue";
import OfferHeaderBlock from "@/components/shop/blocks/OfferHeaderBlock.vue";
import OfferRibbonBlock from "@/components/shop/blocks/OfferRibbonBlock.vue";
import { IMAGES_CDN_URL } from "@/config/constants";
import { useEventStore } from "@/event";
import { type ShopItem } from "@/types/shop";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";

interface Props {
	contentData: ShopItem;
}

const { contentData } = defineProps<Props>();

const eventStore = useEventStore();
const { attributes: eventAttributes } = storeToRefs(eventStore);
</script>

<style lang="scss" scoped>
.event-pass-offer-detail {
	&__content {
		@include flex-col-center;
		min-height: 20rem;

		&-cta {
			@include flex-row-center;
			width: 100%;
			color: #fff;
			font-size: 0.8125rem;
			text-align: center;
			text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
		}

		&-ribbon {
			width: 12.625rem;
			height: 1.875rem;
			@include background(
				url($path-images + "shop/backgrounds/golden-center-ribbon.avif"),
				contain,
				center,
				no-repeat
			);
			@include flex-row-center;
			z-index: 2;
			color: #fff3dd;
			font-weight: 800;
			font-size: 0.875rem;
			line-height: 1;
			text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
			text-transform: uppercase;
		}

		&-rewards {
			position: relative;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			width: 20rem;
			height: 16rem;

			&::before {
				position: absolute;
				top: 50%;
				left: 50%;
				width: 120%;
				height: 120%;
				content: "";
				@include background(
					url($path-images + "shop/backgrounds/radial-glow-xl.avif"),
					contain,
					center,
					no-repeat
				);
				transform: translate(-50%, -50%);
				z-index: -1;
				animation: rotateInfinite 20s linear infinite;
				pointer-events: none;
			}
		}

		&-info {
			position: relative;
			background-image: linear-gradient(
				to right,
				rgba(85, 0, 20, 1),
				rgba(85, 0, 20, 0.8),
				rgba(85, 0, 20, 0.7)
			);
			padding: 0.25rem 2.5rem 0.375rem;
			width: auto;
			@include flex-col-center;
			align-items: flex-start;
			mask-image: linear-gradient(
				to right,
				transparent 2%,
				black 20%,
				black 80%,
				transparent 98%
			);

			&::before,
			&::after {
				position: absolute;
				left: 0;
				z-index: 1;
				background: #cf0032;
				width: 100%;
				height: 0.063rem;
				content: "";
			}

			&::before {
				top: 0;
			}

			&::after {
				bottom: 0;
			}

			span {
				color: #f2dcb5;
				font-weight: 800;
				font-size: 0.875rem;
				line-height: 1.5;
				text-align: center;
				text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
			}
		}
	}
}
</style>
